import React, { FC, ReactNode } from 'react';

import PropTypes from 'prop-types';

import ACCErrorContextSetter from './ACCErrorContextSetter';
import ACCLaunchDarklySubscriber from './ACCLaunchDarklySubscriber';
import ACCLocaleSubscriber from './ACCLocaleSubscriber';
import { AuthenticationListener } from './Authnentication/AuthenticationListener';
import { ProjectAndAccountSetter } from './ProjectAndAccountSetter';

const AlloyContextSubscriber: FC<{ children?: ReactNode }> = ({ children }) => (
  <>
    <AuthenticationListener />
    <ACCLocaleSubscriber />
    <ACCLaunchDarklySubscriber />
    <ACCErrorContextSetter />
    <ProjectAndAccountSetter />
    {children}
  </>
);

AlloyContextSubscriber.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AlloyContextSubscriber;
